import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="w-full bg-gradient-to-br from-red-700 via-red-800 to-red-900 py-20 px-4" data-id="element-12">
      <div className="max-w-4xl mx-auto text-center" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-14">
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6" data-id="element-15">
            Transformá tus clases con el
            <br data-id="element-16" />
            <span className="text-yellow-400" data-id="element-17">Mega Pack Artística Lista</span>
          </h2>

          <p className="text-xl md:text-2xl text-white/90 mb-10 max-w-2xl mx-auto" data-id="element-18">
            Accedé hoy mismo a cientos de recursos, planificaciones y proyectos
            creativos. Empezá a disfrutar más de tu tiempo libre.
          </p>

          <motion.a href="#comprar" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-white text-red-800 px-10 py-5 rounded-lg font-bold text-xl shadow-2xl hover:bg-gray-100 transition-all duration-300" data-id="element-19">
            ¡Quiero el Mega Pack Ahora!
          </motion.a>

          <p className="text-white/80 mt-6 text-sm" data-id="element-20">
            Acceso inmediato • Pago seguro • Garantía de satisfacción
          </p>
        </motion.div>
      </div>
    </section>;
}